/**
 * Traduções de página de erro
 * Inclui: Mensagens e ações da página de erro
 */
export default {
  notFound: {
    title: 'Página Não Encontrada',
    description: 'Desculpe, a página que você está procurando não existe ou foi movida.',
    goHome: 'Voltar para Início',
  },
  devtool: {
    title: 'Ferramentas de Desenvolvedor Detectadas',
    description: 'Para proteger a privacidade e segurança dos dados do usuário, detectamos que você abriu as ferramentas de desenvolvedor do navegador.',
    warning1: 'O uso de ferramentas de desenvolvedor pode expor informações sensíveis do usuário',
    warning2: 'O uso malicioso de ferramentas de desenvolvedor pode levar a roubo de conta ou vazamento de dados',
    warning3: 'Feche as ferramentas de desenvolvedor imediatamente para garantir a segurança da sua conta',
    closeAndReturn: 'Fechei, voltar para início',
    pleaseCloseDevTools: 'Por favor, feche as ferramentas de desenvolvedor primeiro',
  },
}
